<template lang="en">
  <div>
    <div class="ws-textbox overflow-auto">
      <div class="panel h-100">
        <p class="mb-3">{{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_29 || 'Confirm passenger details.' }}</p>
        <div class="vh-pax-container">
            <div class="form-group" v-for="(pax, index) in dataPax" :key="index">
              <div class="row">
                <div class="col-6">
                  <div class="w-100">
                    <div class="name"><span>{{ pax.first_name + ' ' + pax.last_name }}</span></div>
                  </div>
                  <div class="w-100">
                    <div class="pnr"><span>PNR - </span><span >{{ pax.pnr }}</span></div>
                  </div>
                  <div class="w-100">
                    <div class="flight-no"><span>Flight - </span><span>{{ flightinfo.flight_number}}</span></div>
                  </div>
                  <div class="w-100" v-if="pax.segments.length == 0">
                    <div class="router"><span>from</span><span class="text-uppercase route">{{ flightinfo.dep }}</span><span>to</span><span class="text-uppercase route">{{ flightinfo.div }}</span>
                    </div>
                  </div>
                    <div class="w-100" v-else>
                        <div class="router" v-for="(segment, index) in pax.segments" :key="index">
                          <div v-if="isFlightSegment(flightinfo, segment)">
                            <span>from</span>
                            <span class="text-uppercase route">{{ segment.dep }}</span>
                            <span>to</span>
                            <span class="text-uppercase route">{{ segment.arr}}</span>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 text-center">
                  <div class="w-100">
                    <span>{{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_34 || 'This is me' }}</span>
                  </div>
                  <div class="w-100">
                    <input type="checkbox" class="check check-box vhd-checkbox selector" v-model="pax.checked"
                      @click="selectPax(pax)"
                      ></input>
                  </div>
                </div>
              </div>
            <div/>
        </div>
        <br>
        <div class="form-group text-center">
          <button type="button" class="ws-btn hd-normal-btn-color" @click="confirmThisIsMe()">{{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_32 || 'Confirm' }}</button>
        </div>
        <div class="form-group text-center">
          <button type="button" class="ws-btn hd-normal-btn-color" @click="backToSearch()">{{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_33 || 'Back' }}</button>
        </div>
      </div>
      <b-alert
        v-model="showAlertError"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
        variant="danger"
        dismissible
      >
        <div>
          <div v-for="(error, index) in messagesError" :key="index">
            <div>{{ error }}</div>
          </div>
        </div>
      </b-alert>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    step: {
      type: String,
      default: 'this_is_me'
    },
    flightinfo: {
      type: Object,
      default: () => {}
    },
    dataPax: {
      type: Array,
      default: () => []
    },
    paxThisIsMe: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      stepUp: 'confirm',
      messagesError: [],
      showAlertError: false
    }
  },
  watch: {
    showAlertError: function () {
      let self = this
      if (self.showAlertError) {
        setTimeout(function () {
          self.messagesError = []
          self.showAlertError = false
        }, 5000)
      }
    }
  },
  mounted() {
    this.searchPassenger()
  },
  methods: {
    confirmThisIsMe() {
      let self = this
      if (_.isEmpty(self.paxThisIsMe)) {
        this.messagesError = []
        this.messagesError.push('Please select passenger.')
        this.showAlertError = true
        return
      }
      const _curPax = self.dataPax.find((pax) => pax.id == self.paxThisIsMe.id && pax.checked)
      if (_.isEmpty(_curPax)) {
        this.messagesError = []
        this.messagesError.push('Please select passenger.')
        this.showAlertError = true
        return
      }
      if (this.isInfant(_curPax)) {
        this.messagesError = []
        this.messagesError.push('The infant passenger cannot confirm this is me.')
        this.showAlertError = true
        return
      }
      //add group pax for pasenger
      let groups = _.groupBy(self.dataPax, 'group_id')
      _curPax.groups = groups[_curPax.group_id]
      self.stepUp = 'confirm'
      self.$emit('setThisIsMe', _curPax)
      self.$emit('updateStep', self.stepUp)
    },
    selectPax(pax) {
      let id = pax.id

      let groupPaxs = this.dataPax.map(function (_pax) {
        if (_pax.id == id) {
          _pax.checked = !_pax.checked
        } else {
          _pax.checked = false
        }
        return _pax
      })
      this.$emit('setThisIsMe', pax)
      this.$emit('updateListDataPax', groupPaxs)
    },
    backToSearch() {
      this.stepUp = 'search'
      this.$emit('updateStep', this.stepUp)
      // reset data
      this.$emit('updateListFlight', [])
      this.$emit('updateFlightInfo', null)
      this.$emit('updateListDataPax', [])
      this.$emit('updateDataSearchPax', null)
      this.$emit('setThisIsMe', {})
    },
    isInfant(pax) {
      let ssrs = []
      try {
        ssrs = JSON.parse(pax.ssrs || '[]')
      } catch (error) {
        console.error('Error parsing JSON:', error)
      }
      if (pax.invoicing_flag === 'INFT' && !ssrs.some((ssr) => ssr.type === 'INFT')) {
        // define ssr object via amadeus
        const infant = {
          type: 'INFT',
          key: '#INFT',
          ssrValue: {}
        }
        ssrs.push(infant)
      }
      return ssrs.some((ssr) => ssr.type === 'INFT')
    },
    isFlightSegment(flightinfo, segment) {
      if (_.isEmpty(flightinfo) || _.isEmpty(segment)) {
        return false
      }
      //find flight's segment
      if (flightinfo.carrier == segment.carrier && flightinfo.flight_no == segment.flight_no) {
        return true
      }
      return false
    },
    searchPassenger() {
      if (_.isEmpty(this.dataPax)) {
        this.$emit('searchPassenger')
      }
    }
  }
}
</script>
<style>
.name span {
  font-size: 16px;
  line-height: 1.15;
  margin-bottom: 0.25rem;
}
.route {
  font-weight: 500;
  padding: 0.25rem;
}
.bradius {
  border-radius: 14px;
  width: 120px;
}
.vh-pax-container {
  min-height: 55vh;
  font-size: 14px;
}
.bold {
  font-weight: 500;
}
.vhd-checkbox {
  height: 1.25rem;
  width: 1.25rem;
  background-color: #ffffff;
  border: 0.125rem solid #979797;
  border-radius: 0.3125rem;
  transform: translateY(50%);
}
</style>
